export default "__VITE_ASSET__DD9yaTc0__"